import { useI18n } from '@packages/shared';
import { getUspDataCacheKey } from './getUspData';

export const useUspCacheKey = () => {
  const { locale } = useI18n();

  return getUspDataCacheKey(locale);
};
